// // ProtectedRoute.js
// import React from 'react';
// import { Navigate, Outlet } from 'react-router-dom';
// import { useAuth } from './AuthContext';

// const ProtectedRoute = () => {
//   const { isAuthenticated, isAdmin, loading } = useAuth();

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-emerald-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-teal-600 mx-auto mb-4"></div>
//           <p className="text-gray-600 font-medium">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   // If admin tries to access user routes, redirect to admin dashboard
//   if (isAdmin) {
//     return <Navigate to="/admin-dashboard" replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;


// components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  if (!user) {
    // User not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin()) {
    // User logged in but not admin, redirect to home or show unauthorized
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;